import 'reflect-metadata';
import {
    AfterLoad,
    BeforeInsert,
    Column,
    Entity,
    JoinColumn,
    JoinTable,
    ManyToMany,
    ManyToOne,
    OneToMany,
    PrimaryGeneratedColumn,
} from 'typeorm';
import {
    BaseEntite,
    Contact,
    EntiteStatique,
    Fichier,
    Fournisseur,
    Langue,
    Lieu,
    Thematique,
    MethodePaiement,
    Etiquette,
    FournisseurVitrine,
} from '.';
import ContactActivite from './contact-activite.entity';
import Images from './image.entity';
import LieuActivite from './lieu-activite.entity';
import ActiviteProduit from './activite-produit.entity';
import { ModeleHoraire } from './modele-horaire.entity';
import { ModeleHoraireActivite } from './modele-horaire-activite.entity';

@EntiteStatique()
@Entity('type_activite')
export class TypeActivite implements BaseEntite {
    static key = 'type-activite';
    @PrimaryGeneratedColumn()
    id: number;
    @Column()
    name: string;
}

@EntiteStatique()
@Entity('activite')
export class Activite implements BaseEntite {
    static key = 'activites';

    constructor() {
        this.created_at = '';
        this.description = '';
        this.ville = '';
        this.covid = '';
        this.covid_description = '';
        this.alerte = '';
        this.temps_avance_animateur = '';
        this.ratio_groupe = '';
        this.public_cible = '';
        this.locaux = '';
        this.minimum_facturable_nombre = '';
        this.minimum_facturable_type = '';
        this.minimum_facturable_texte = '';
        this.name = '';
        this.notes = '';
        this.notes_fournisseur = '';
        this.notes_client = '';
        this.periode_ouverture = '';
        this.tarifs_estimes = '';
        this.pct_commission_defaut = '';
        this.actif = true;
        this.taxable = true;
        this.public = false;
        this.max_participants = '';
        this.max_participants_type = '';
        this.max_participants_texte = '';
        this.max_participants_visible = false;
        this.avis_nb_participants = '';
        this.signer_contrat = false;
        this.guide_type_accueil = '';
        this.guide_creation_horaire = '';
        this.guide_minimum_facturable_jour_anim_client = '';
        this.guide_minimum_facturable_jour_anim_fournisseur = '';
        this.guide_changement_prix = '';
        this.guide_FAQ = '';
        this.guide_preparation = '';
        this.guide_clauses_politiques = '';
        this.public_date_echeance = '';
    }

    @PrimaryGeneratedColumn()
    id: number;
    @Column({ type: 'timestamp', nullable: true })
    created_at: string;
    @Column({ nullable: true })
    description: string;
    @Column({ nullable: true })
    ville: string;
    @Column({ nullable: true })
    covid: string;
    @Column({ nullable: true })
    covid_description: string;
    @Column({ nullable: true })
    alerte: string;
    @Column({ nullable: true })
    temps_avance_animateur: string;
    @Column({ nullable: true })
    ratio_groupe: string;
    @Column({ nullable: true })
    public_cible: string;
    @Column({ nullable: true })
    locaux: string;
    @Column({ nullable: true })
    fk_id_fournisseur: number;
    @ManyToOne(() => Fournisseur)
    @JoinColumn({ name: 'fk_id_fournisseur', referencedColumnName: 'id' })
    fournisseur: Fournisseur;
    @Column({ type: 'integer', nullable: true })
    minimum_facturable_nombre: number | '';
    @Column({ nullable: true })
    minimum_facturable_type: string;
    @Column({ nullable: true })
    minimum_facturable_texte: string;
    @Column()
    name: string;
    @Column({ nullable: true })
    notes: string;
    @Column({ nullable: true })
    notes_fournisseur: string;
    @Column({ nullable: true })
    notes_client: string;
    @Column({ nullable: true })
    periode_ouverture: string;
    @Column({ nullable: true })
    tarifs_estimes: string;
    @Column({ nullable: false })
    fk_id_type_activite: number;
    @ManyToOne(() => TypeActivite)
    @JoinColumn({ name: 'fk_id_type_activite', referencedColumnName: 'id' })
    typeActivite: TypeActivite;
    @Column({ type: 'numeric', nullable: true })
    pct_commission_defaut: number | '';
    @Column({ name: 'b_actif', nullable: true, default: true })
    actif: boolean;
    @Column({ name: 'b_taxable', nullable: true, default: true })
    taxable: boolean;
    @Column({ name: 'b_public', nullable: true, default: false })
    public: boolean;
    @Column({ type: 'integer', nullable: true })
    max_participants: number | '';
    @Column({ nullable: true })
    max_participants_type: string;
    @Column({ nullable: true })
    horaire_type: string;
    @Column({ nullable: true })
    questionnaire_logistique: string;
    @Column({ nullable: true })
    max_participants_texte: string;
    @Column({ default: false })
    max_participants_visible: boolean;
    @Column({ default: false })
    ficav: boolean;
    @Column({ nullable: true })
    avis_nb_participants: string;
    @Column({ nullable: true, default: false })
    signer_contrat: boolean;
    @Column({ nullable: true })
    fk_id_contact_par_defaut: number;
    @ManyToOne(() => Contact)
    @JoinColumn({ name: 'fk_id_contact_par_defaut', referencedColumnName: 'id' })
    contact_par_defaut: Contact;
    @Column({ nullable: true })
    fk_id_lieu: number;
    @ManyToOne(() => Lieu, (lieu: Lieu) => lieu.activites)
    @JoinColumn({ name: 'fk_id_lieu', referencedColumnName: 'id' })
    adresse_calcul_km: Lieu;
    @Column({ type: 'integer', nullable: true })
    priorite: number | '';
    @Column({ nullable: true })
    guide_type_accueil: string;
    @Column({ nullable: true })
    guide_creation_horaire: string;
    @Column({ nullable: true })
    guide_minimum_facturable_jour_anim_client: string;
    @Column({ nullable: true })
    guide_minimum_facturable_jour_anim_fournisseur: string;
    @Column({ nullable: true })
    guide_changement_prix: string;
    @Column({ nullable: true, name: 'guide_faq' })
    guide_FAQ: string;
    @Column({ nullable: true })
    guide_preparation: string;
    @Column({ nullable: true })
    guide_clauses_politiques: string;
    @Column({ nullable: true })
    fk_id_image_principale: number;
    @Column({ nullable: true })
    fk_id_fichier_annexe?: number;
    @Column({ type: 'date', nullable: true })
    trigger_suivi = '';
    @Column({ type: 'date', nullable: true })
    public_date_echeance?: string = '';
    @OneToMany(() => Images, (image: Images) => image.activites)
    fichiers: Images[];
    @Column({ nullable: true })
    fk_methode_paiement: number;
    @ManyToOne(() => MethodePaiement)
    @JoinColumn({ name: 'fk_methode_paiement', referencedColumnName: 'id' })
    methode_paiement: MethodePaiement;
    @Column({ type: 'text', nullable: true })
    nom_acces_d = '';

    @OneToMany(() => ActiviteProduit, (activite_produit: ActiviteProduit) => activite_produit.activite, {
        cascade: true,
    })
    activiteProduits: ActiviteProduit[];

    @OneToMany(() => Thematique, (thematique: Thematique) => thematique.activite, { cascade: true })
    thematiques: Thematique[];

    @OneToMany(() => LieuActivite, (lieuActivite: LieuActivite) => lieuActivite.activite)
    lieux: LieuActivite[];

    @OneToMany(() => ContactActivite, (contactActivite: ContactActivite) => contactActivite.activite)
    contacts: ContactActivite[];

    @ManyToMany(() => Etiquette)
    @JoinTable({
        name: 'activite_etiquette',
        joinColumn: {
            name: 'fk_id_activite',
            referencedColumnName: 'id',
        },
        inverseJoinColumn: {
            name: 'fk_id_etiquette',
            referencedColumnName: 'id',
        },
    })
    etiquettes: Etiquette[];

    @ManyToMany(() => Langue, (langue: Langue) => langue.activites)
    langues: Langue[];

    @ManyToOne(() => Fichier)
    @JoinColumn({ name: 'fk_id_fichier_annexe', referencedColumnName: 'id' })
    piece_jointe: Fichier;

    @Column({ nullable: true })
    fk_id_horaire_par_defaut: number;

    @ManyToOne(() => ModeleHoraire)
    @JoinColumn({ name: 'fk_id_horaire_par_defaut', referencedColumnName: 'id' })
    horaireParDefaut: ModeleHoraire;

    @BeforeInsert()
    updateCreatedAt(): void {
        this.created_at = new Date().toUTCString();
    }

    @OneToMany(
        () => ModeleHoraireActivite,
        (modeleHoraireActivite: ModeleHoraireActivite) => modeleHoraireActivite.activite,
        { cascade: true },
    )
    modelesHorairesActivite: ModeleHoraireActivite[];

    minimum_facturable: string;
    @AfterLoad()
    setMinimumFacturable(): void {
        this.minimum_facturable =
            (this.minimum_facturable_nombre ? `${this.minimum_facturable_nombre} ` : '') +
            (this.minimum_facturable_type ? `${this.minimum_facturable_type} ` : '') +
            (this.minimum_facturable_texte ? `${this.minimum_facturable_texte}` : '');
    }

    vitrine_maximum_participants: string;
    @AfterLoad()
    setMaximumParticipant(): void {
        this.vitrine_maximum_participants =
            (this.max_participants ? `${this.max_participants} ` : '') +
            (this.max_participants_type ? `${this.max_participants_type} ` : '') +
            (this.max_participants_texte ? `${this.max_participants_texte}` : '');
    }
}

@Entity('activite', { synchronize: false })
export class ActiviteVitrine implements BaseEntite {
    static key = 'activites';

    constructor() {
        this.name = '';
        this.actif = true;
        this.public = false;
        this.description = '';
        this.periode_ouverture = '';
        this.minimum_facturable_nombre = '';
        this.minimum_facturable_type = '';
        this.minimum_facturable_texte = '';
        this.tarifs_estimes = '';
        this.notes = '';
        this.public_date_echeance = '';
    }

    @PrimaryGeneratedColumn()
    id: number;
    @Column({ type: 'timestamp', nullable: true })
    created_at: string;
    @Column()
    name: string;
    @ManyToOne(() => TypeActivite)
    @JoinColumn({ name: 'fk_id_type_activite', referencedColumnName: 'id' })
    typeActivite: TypeActivite;
    @Column({ nullable: true })
    fk_id_image_principale: number;
    @Column({ type: 'integer', nullable: true })
    priorite: number | '';
    @Column({ nullable: false })
    fk_id_type_activite: number;
    @Column({ name: 'b_actif', nullable: true, default: true })
    actif: boolean;
    @Column({ name: 'b_public', nullable: true, default: false })
    public: boolean;
    @Column({ type: 'date', nullable: true })
    public_date_echeance?: string = '';
    @Column({ nullable: true })
    fk_id_fournisseur: number;
    @ManyToOne(() => FournisseurVitrine)
    @JoinColumn({ name: 'fk_id_fournisseur', referencedColumnName: 'id' })
    fournisseur: FournisseurVitrine;
    @ManyToMany(() => Etiquette, { eager: true })
    @JoinTable({
        name: 'activite_etiquette',
        joinColumn: {
            name: 'fk_id_activite',
            referencedColumnName: 'id',
        },
        inverseJoinColumn: {
            name: 'fk_id_etiquette',
            referencedColumnName: 'id',
        },
    })
    etiquettes: Etiquette[];
    @Column({ nullable: true })
    description: string;
    @Column({ nullable: true })
    periode_ouverture: string;
    minimum_facturable: string;
    @AfterLoad()
    setMinimumFacturable(): void {
        this.minimum_facturable =
            (this.minimum_facturable_nombre ? `${this.minimum_facturable_nombre} ` : '') +
            (this.minimum_facturable_type ? `${this.minimum_facturable_type} ` : '') +
            (this.minimum_facturable_texte ? `${this.minimum_facturable_texte}` : '');
    }
    @Column({ type: 'integer', nullable: true })
    minimum_facturable_nombre: number | '';
    @Column({ nullable: true })
    minimum_facturable_type: string;
    @Column({ nullable: true })
    minimum_facturable_texte: string;
    @Column({ nullable: true })
    tarifs_estimes: string;
    @Column({ nullable: true })
    fk_id_contact_par_defaut: number;
    @ManyToOne(() => Contact)
    @JoinColumn({ name: 'fk_id_contact_par_defaut', referencedColumnName: 'id' })
    contact_par_defaut: Contact;
    @Column({ nullable: true })
    notes: string;
}
